import React from "react";
import ImageProfail from "../../../components/ImageProfail";

export default function ProfailImages({ mosqueId, mosqueData }) {
    return (
        <div className="pv2-image-container">
            <ImageProfail id={1} label={"Logo"} mosqueId={mosqueId} imagePath={mosqueData?.logo} />

            {/* ✅ auto generate OG bila upload Gambar */}
            <ImageProfail
                id={2}
                label={"Gambar"}
                mosqueId={mosqueId}
                imagePath={mosqueData?.gambar}
                autoOg
            />

            <ImageProfail id={3} label={"Duit Now QR"} mosqueId={mosqueId} imagePath={mosqueData?.qr} />
        </div>
    );
}
